import React from 'react'
import styled from 'styled-components'
import octicons from './octicons'
import colors from './colors'
import sizes from './sizes'

// FIXME static octicon classes leaning on Elemental to avoid duplicate
// font and CSS inflating the project size

export function Glyph({
  aphroditeStyles,
  className,
  color,
  component: Component,
  name,
  size,
  style,
  ...props
}) {
  const StyledGlyph = styled(Component || 'i')`
    margin: 4px;
    color: ${(props) => colors[props.color] || props.color || 'inherit'};
    font-size: ${(props) => sizes[props.size] || sizes.small}px;
  `

  return (
    <StyledGlyph
      color={color}
      size={size}
      className={`${octicons[name]} ${className || ''}`}
      style={style}
      {...props}
    />
  )
}

Glyph.defaultProps = {
  component: 'i',
  color: 'inherit',
  size: 'small'
}

export default Glyph
